<template>
  <div class="home">

    <Hero />
    <Assignment />
    <Register id="register" :submissions="allowSubmissions" />
    <Leaderboard v-if="allowSubmissions" />

  </div>
</template>
<script>
import Hero from '@/components/Hero'
import Assignment from '@/components/Assignment'
import Register from '@/components/Register'
import Leaderboard from '@/components/Leaderboard'
export default {
  components: {
    Hero,
    Assignment,
    Register,
    Leaderboard
  },
  computed: {
    allowSubmissions() {
      return true
      // 2021-10-16 @ 09:00:00
      const reveal = 1634367600 * 1000
      const date = Date.now()
      return date < reveal
    }
  }
}
</script>
